import Toggle from "../../components/Toggle/Toggle";
import TableButton from '../../components/Table/TableButton/TableButton';
import { FaPen ,FaTrashAlt } from 'react-icons/fa';
const handleProductClick = (product) => {
    // setSelectedProduct(product);
    // setIsProductModalOpen(true);
  };

const handleUsageToggle = (productId) => {
    // setFinishedProducts(finishedProducts.map(product => 
    //   product.id === productId 
    //     ? {...product, isUsed: !product.isUsed} 
    //     : product
    // ));
  };

export const productStockManageManagementColumns = [
  { header: '생성일', accessor: 'devDt' },
  { header: '제품명', accessor: 'productName' },
  { header: '규격', accessor: 'specification' },
  { header: '단위', accessor: 'stockUnitCode' },
  { header: '제품코드', accessor: 'code' },
  { header: '잔량', accessor: 'amount' },
  { header: '수주발생', accessor: 'contractCnt' },
  { header: '생산수량', accessor: 'productCnt' },
  { header: '예상 제작 단가', accessor: 'predictPrice', render: (row) => `${(row.predictPrice ?? 0).toLocaleString()} 원` },
  { header: '판매 금액', accessor: 'price', render: (row) => `${row.price.toLocaleString()} 원` },
  { header: '잔량 금액', accessor: 'amountPrice', render: (row) => `${row.amountPrice.toLocaleString()} 원` },
  { header: '재고관리', accessor: 'useStockManagement', render: (row) => (
    <Toggle
      isOn={row.useStockManagement}
      handleToggle={()=>{}}
      onText="사용"
      offText="미사용"
    />
  )},
  { header: '사용', accessor: 'isUseFlag', render: (row) => (
    <Toggle
      isOn={row.isUseFlag}
      handleToggle={()=>{}}
      onText="사용"
      offText="미사용"
    />
  )},
  // { header: '상세보기', accessor: 'details', render: (row) => (
  //   <TableButton text="상세보기" onClick={() => handleProductClick(row)} className="detail-view"/>
  // )},
];
export const productStockSearchFormFields = [
  { key: "devDt", label: "개발일", type: "date", size: 6, visible: true },
  // { key: "devDtEnd", label: "개발일 (끝)", type: "date", size: 6, visible: true },
  { key: "userSeq", label: "담당자", type: "apiSelect", apiKey: "user", labelKey: "userName", valueKey: "userSeq", visible: true },
  { key: "productName", label: "제품명", type: "text", size: 6, visible: true },
  { key: "code", label: "제품 코드", type: "text", size: 6, visible: true },
  { key: "useStockManagement", label: "재고 관리", type: "checkbox", onText: "사용", offText: "미사용", size: 6, visible: true, default : false },
  { key: "useFlag", label: "사용 여부", type: "checkbox", onText: "사용", offText: "미사용", size: 6, visible: true, default : false }
];
export const productInColumns = (openModal, clickDelete) => [
  { header: '입고일', accessor: 'warehousingDt' },
  {
    header: '유형',
    accessor: 'inTypeCode',
    render: (row) => {
      const typeMap = {
        1: '생산',
        2: '구매',
        3: '반품',
      };
      return typeMap[row.inTypeCode] || '기타';
    }
  },
  { header: '수량', accessor: 'amount' , render: (row) => `${ row.amount.toLocaleString() }` },
  { header: '수정',accessor: 'update', render: (row) =>
    <span onClick={(e) => {e.stopPropagation(); openModal( 2, 1, row)}} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', render: (row) =>
    <span onClick={(e) => { e.stopPropagation(); clickDelete(1, row) }} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];

export const productInFormFields = [
  { key: "productInSeq", label: "입고번호", type: "text", size: 6, visible: false, required: false },
  { key: "productSeq", label: "제품번호", type: "text", size: 6, visible: false, required: false },
  { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "warehousingDt", label: "입고 일", type: "date", size: 6, visible: true, required: true },
  { key: "inTypeCode",
    label: "유형",
    type: "select",
    size: 6,
    visible: true,
    required: false,
    options: [
      { label: "생산", value: "1" },
      { label: "반품", value: "3" },
    ]
  },
  { key: "amount", label: "수량", type: "number", size: 6, visible: true, required: true },
]

export const productOutColumns = (openModal, clickDelete) => [
  { header: '출고일', accessor: 'forwardingDt' },
  { header: '수주번호', accessor: 'contractNum' },
  { header: '출고자', accessor: 'name' },
  { header: '수량', accessor: 'amount', render: (row) => `${ row.amount.toLocaleString() }`},
  { header: '출고단가', accessor: 'price', render: (row) => `${ row.price.toLocaleString() } 원` },
  { header: '합계', accessor: 'total', render: (row) => `${ row.total.toLocaleString() } 원` },
  { header: '세액', accessor: 'tax', render: (row) => `${ row.tax.toLocaleString() } 원` },
  { header: '수정',accessor: 'update', render: (row) =>
    <span onClick={(e) => { e.stopPropagation(); openModal( 2, 2, row) }} style={{ cursor: 'pointer' }}><FaPen/></span>
  },
  { header: '삭제', accessor: 'delete', render: (row) =>
    <span onClick={(e) => { e.stopPropagation(); clickDelete(2, row) }} style={{ cursor: 'pointer' }}><FaTrashAlt/></span>
  },
];

export const productOutFormFields= [
  { key: "productOutSeq", label: "출고번호", type: "text", size: 6, visible: false, required: false },
  { key: "productSeq", label: "공정번호", type: "text", size: 6, visible: false, required: false },
  { key: "companySeq", label: "회사번호", type: "text", size: 6, visible: false, required: false },
  { key: "forwardingDt", label: "출고일", type: "date", size: 6, visible: true, required: true },
  { key: "contractSeq", label: "수주 번호", type: "apiSelect", apiKey: 'contract',  labelKey: "contractNum", valueKey: "contractSeq", size: 6, visible: true, required: true },
  { key: "userSeq", label: "출고자", type: "apiSelect", apiKey: 'user',  labelKey: "userName", valueKey: "userSeq", size: 6, visible: true, required: true },
  { key: "amount", label: "수량", type: "number", size: 6, visible: true, required: true },
]